// Diaporama du hero : photo de couverture de la page #accueil + images de son corps (galerie).
// Rotation automatique seulement sans « réduire les animations », mise en pause au survol, au focus,
// quand l'onglet est caché, ou par le bouton (mémorisé pour la session). Une seule photo : aucun contrôle.
const ICONES = {
    prec: '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6"/></svg>',
    suiv: '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>',
    pause: '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14M16 5v14"/></svg>',
    lecture: '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m7 4 13 8-13 8z"/></svg>'
};
const norm = (s) => (s || "").replace(/\/size\/w\d+\//, "/");

export default function diapo() {
    const d = document.querySelector("[data-diapo]");
    if (!d) return;

    const tpl = d.querySelector("template");
    if (tpl) {
        const vus = [...d.querySelectorAll("figure img")].map((i) => norm(i.getAttribute("src")));
        tpl.content.querySelectorAll("img").forEach((i) => {
            const src = i.getAttribute("src");
            if (!src || vus.includes(norm(src))) return;
            vus.push(norm(src));
            const f = document.createElement("figure");
            const n = new Image();
            n.src = src;
            if (i.getAttribute("srcset")) n.srcset = i.getAttribute("srcset");
            n.sizes = "100vw";
            n.alt = i.getAttribute("alt") || "";
            n.loading = "lazy";
            n.decoding = "async";
            f.append(n);
            d.insertBefore(f, tpl);
        });
        tpl.remove();
    }

    const figs = [...d.querySelectorAll("figure")];
    if (!figs.length) { d.closest(".hero")?.classList.remove("a-photos"); d.remove(); return; }
    figs[0].classList.add("est-active");
    if (figs.length < 2) return;

    d.setAttribute("role", "region");
    d.setAttribute("aria-roledescription", "diaporama");
    d.setAttribute("aria-label", "Photos de la commune");
    figs.forEach((f, k) => {
        f.setAttribute("role", "group");
        f.setAttribute("aria-roledescription", "photo");
        f.setAttribute("aria-label", `${k + 1} sur ${figs.length}`);
        f.setAttribute("aria-hidden", String(k !== 0));
    });

    const reduit = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let pause = reduit;
    try { if (sessionStorage.getItem("mz-diapo") === "pause") pause = true; } catch (e) { /* ignore */ }
    let i = 0, minuteur = 0, survol = false;

    const nav = document.createElement("div");
    nav.className = "diapo-nav";
    nav.setAttribute("role", "group");
    nav.setAttribute("aria-label", "Commandes du diaporama");
    nav.innerHTML = `<button type="button" data-prec aria-label="Photo précédente">${ICONES.prec}</button><button type="button" data-pause></button><button type="button" data-suiv aria-label="Photo suivante">${ICONES.suiv}</button>`;
    d.closest(".hero").append(nav);
    const bPause = nav.querySelector("[data-pause]");

    const aller = (n) => {
        figs[i].classList.remove("est-active"); figs[i].setAttribute("aria-hidden", "true");
        i = (n + figs.length) % figs.length;
        figs[i].classList.add("est-active"); figs[i].setAttribute("aria-hidden", "false");
    };
    const arret = () => { clearInterval(minuteur); minuteur = 0; };
    const marche = () => { if (!pause && !survol && !document.hidden && !minuteur) minuteur = setInterval(() => aller(i + 1), 7000); };
    const afficher = () => {
        bPause.innerHTML = pause ? ICONES.lecture : ICONES.pause;
        bPause.setAttribute("aria-label", pause ? "Reprendre le diaporama" : "Mettre le diaporama en pause");
        d.setAttribute("aria-live", pause ? "polite" : "off");
    };

    bPause.addEventListener("click", () => {
        pause = !pause;
        try { pause ? sessionStorage.setItem("mz-diapo", "pause") : sessionStorage.removeItem("mz-diapo"); } catch (e) { /* ignore */ }
        afficher(); pause ? arret() : marche();
    });
    nav.querySelector("[data-prec]").addEventListener("click", () => aller(i - 1));
    nav.querySelector("[data-suiv]").addEventListener("click", () => aller(i + 1));
    nav.addEventListener("mouseenter", () => { survol = true; arret(); });
    nav.addEventListener("mouseleave", () => { survol = false; marche(); });
    nav.addEventListener("focusin", () => { survol = true; arret(); });
    nav.addEventListener("focusout", () => { survol = false; marche(); });
    document.addEventListener("visibilitychange", () => (document.hidden ? arret() : marche()));

    afficher();
    marche();
}
